import React, { FunctionComponent, useLayoutEffect } from 'react';
import TagManager from 'react-gtm-consent-module';
import { Helmet } from 'react-helmet';
import { getTagAttributes } from '../../..';
import { IMetaData } from '../../../models/common/metadata-tagging/meta-data.model';
import { ITagging } from '../../../models/common/metadata-tagging/tagging.model';

type MetaDataProps = {
  metaData?: IMetaData | null;
  tagging?: ITagging | null;
};

export const MetaDataAndTagging: FunctionComponent<MetaDataProps> = (props: MetaDataProps) => {
  // tagging
  useLayoutEffect(() => {
    // GTM datalayer
    if (props.tagging?.gtm?.dataLayer && props.tagging.gtm.dataLayer.innerHtml) {
      if (props.tagging.gtm.dataLayer && props.tagging.gtm.dataLayer.innerHtml) {
        var objArr = JSON.parse(props.tagging.gtm.dataLayer.innerHtml) as any[];
        if (Array.isArray(objArr)) {
          objArr?.forEach((o) => {
            const tag = {
              dataLayer: o,
            };
            TagManager.dataLayer(tag);
          });
        } else {
          const tag = {
            dataLayer: JSON.parse(props.tagging.gtm.dataLayer.innerHtml),
          };
          TagManager.dataLayer(tag);
        }
      }
    }

    //GA4 datalayer
    if (props.tagging?.ga4 && props.tagging.ga4.length > 0) {
      props.tagging.ga4.forEach((tagData) => {
        let w = window as any;

        w.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        w.dataLayer.push(tagData);
      });
    }
  }, [props.tagging]);

  return (
    <Helmet>
      <title>{props.metaData?.pageTitle}</title>
      {props.metaData?.canonicalUrl && <link rel='canonical' href={props.metaData?.canonicalUrl} />}

      {props.metaData?.structuredData && (
        <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: props.metaData?.structuredData }}></script>
      )}

      {props.metaData?.metaTags?.map((mt, i) => {
        return <meta {...getTagAttributes(mt.attributes)} key={i} />;
      })}

      {props.metaData?.links?.map((link, i) => {
        return <link {...getTagAttributes(link.attributes)} key={i}></link>;
      })}

      {props.tagging?.tags?.map((sd, i) => {
        if (sd.name === 'script') {
          return (
            <script {...getTagAttributes(sd.attributes)} key={i}>
              {sd.innerHtml}
            </script>
          );
        }
      })}
    </Helmet>
  );
};
